import React from 'react';
import { LucideIcon, TrendingUp, TrendingDown } from 'lucide-react';

type IconColor = 'blue' | 'teal' | 'green' | 'red' | 'purple' | 'yellow' | 'orange';

interface Props {
  title: string;
  value: string | number;
  icon: string | LucideIcon;
  color?: IconColor;
  change?: {
    value: number;
    type: 'increase' | 'decrease';
  };
  subtitle?: string;
  className?: string;
}

const iconColorMap: Record<IconColor, string> = {
  blue:   'stat-icon-blue',
  teal:   'stat-icon-teal',
  green:  'stat-icon-teal',
  red:    'stat-icon-red',
  purple: 'stat-icon-purple',
  yellow: 'stat-icon-orange',
  orange: 'stat-icon-orange',
};

export default function StatsCard({ title, value, icon, color = 'blue', change, subtitle, className = '' }: Props) {
  const IconComponent = typeof icon !== 'string' ? icon as LucideIcon : null;
  const emojiIcon     = typeof icon === 'string' ? icon : null;
  const iconClass     = iconColorMap[color];

  return (
    <div className={`stat-card ${className}`}>
      {/* Icon */}
      <div className={iconClass}>
        {IconComponent
          ? <IconComponent className="h-5 w-5" />
          : <span className="text-xl leading-none">{emojiIcon}</span>
        }
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <p className="stat-label truncate">{title}</p>
        <p className="stat-value mt-0.5">{value}</p>

        <div className="flex items-center gap-2 mt-1.5">
          {change && (
            <span className={`flex items-center gap-0.5 ${change.type === 'increase' ? 'stat-change-up' : 'stat-change-down'}`}>
              {change.type === 'increase'
                ? <TrendingUp className="h-3 w-3" />
                : <TrendingDown className="h-3 w-3" />
              }
              {Math.abs(change.value)}%
            </span>
          )}
          {subtitle && (
            <span className="text-xs text-gray-400 truncate">{subtitle}</span>
          )}
        </div>
      </div>
    </div>
  );
}
